var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"padding":""}},[_c('div',[_vm._v("\n    Validating...\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }